import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function Terms() {
  return (
    <>
      <Helmet>
        <title>Terms of Service - Aramco Leads Pro</title>
        <meta name="description" content="Terms of Service for Aramco Leads Pro CRM platform." />
      </Helmet>

      <div style={{ background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)', color: 'white', padding: '4rem 2rem', textAlign: 'center' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h1 style={{ fontSize: '3rem', fontWeight: '800', marginBottom: '0.5rem' }}>Terms of Service</h1>
          <p style={{ fontSize: '0.95rem', opacity: 0.85 }}>Last Updated: December 2, 2025</p>
        </div>
      </div>

      <section style={{ padding: '4rem 2rem', background: '#f9fafb' }}>
        <div style={{ maxWidth: '800px', margin: '0 auto', lineHeight: '1.8' }}>
          <div style={{ background: 'white', padding: '3rem', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
            
            <p style={{ marginBottom: '2rem' }}>
              These Terms of Service ("Terms") govern your use of services provided by Aramco 1 USA Corporation, doing business as Aramco Leads Pro ("Company," "we," "our," or "us"). By using our CRM platform, you agree to these Terms.
            </p>

            <h2 style={{ color: '#1e40af', marginBottom: '1rem', fontSize: '1.75rem' }}>1. Services Offered</h2>
            <p style={{ marginBottom: '1rem' }}>Aramco Leads Pro provides:</p>
            <ul style={{ marginBottom: '2rem', paddingLeft: '2rem' }}>
              <li><strong>CRM Platform:</strong> Lead tracking, contact management, and customer relationship tools</li>
              <li><strong>Customer Notifications:</strong> Appointment reminders, follow-up messages, order updates</li>
              <li><strong>Communication Tools:</strong> Automated messaging for customer service and engagement</li>
              <li><strong>Analytics:</strong> Reporting and insights on lead conversion and customer engagement</li>
            </ul>

            <h2 style={{ color: '#1e40af', marginBottom: '1rem', fontSize: '1.75rem' }}>2. User Responsibilities</h2>
            <p style={{ marginBottom: '1rem' }}>Users must:</p>
            <ul style={{ marginBottom: '2rem', paddingLeft: '2rem' }}>
              <li>Obtain explicit opt-in consent from customers before sending messages</li>
              <li>Provide accurate sender information</li>
              <li>Respect STOP/UNSUBSCRIBE requests immediately</li>
              <li>Comply with TCPA, CTIA, and carrier policies</li>
              <li>Maintain records of consent and opt-out requests</li>
              <li>Use services only for legal, compliant purposes</li>
            </ul>

            <h2 style={{ color: '#1e40af', marginBottom: '1rem', fontSize: '1.75rem' }}>3. Consent Requirements</h2>
            <div style={{ background: '#dbeafe', padding: '1.5rem', borderRadius: '8px', marginBottom: '2rem', border: '2px solid #3b82f6' }}>
              <p style={{ color: '#1e3a8a', fontWeight: '600', marginBottom: '0.5rem' }}>Required Consent:</p>
              <p style={{ color: '#1e3a8a' }}>
                You must ensure customers have knowingly provided their contact information, been informed about message types, 
                and provided clear opt-in consent before using our platform to communicate with them.
              </p>
            </div>

            <h2 style={{ color: '#1e40af', marginBottom: '1rem', fontSize: '1.75rem' }}>4. Lending Services Terms</h2>
            <div style={{ background: '#fef3c7', padding: '1.5rem', borderRadius: '8px', marginBottom: '2rem', border: '2px solid #f59e0b' }}>
              <p style={{ color: '#92400e', fontWeight: '600', marginBottom: '1rem' }}>Special Terms for Lending and Financial Services:</p>
              <ul style={{ paddingLeft: '2rem', color: '#78350f', marginBottom: '1rem' }}>
                <li>Aramco Leads Pro may offer information about lending and loan products</li>
                <li>We are not a direct lender and do not make credit decisions</li>
                <li>Loan offers are subject to lender approval and creditworthiness</li>
                <li>Interest rates, fees, and terms vary by lender</li>
                <li>You are not obligated to accept any loan offer</li>
                <li>SMS consent is separate from any loan application or agreement</li>
                <li>We comply with all applicable federal and state lending laws</li>
                <li>We do not engage in predatory lending practices</li>
              </ul>
              <p style={{ fontSize: '0.9rem', color: '#92400e', fontWeight: '600' }}>
                For complete lending disclosures, see our{' '}
                <a href="/lending-compliance" style={{ color: '#92400e', textDecoration: 'underline' }}>Lending Compliance</a> page.
              </p>
            </div>

            <h2 style={{ color: '#1e40af', marginBottom: '1rem', fontSize: '1.75rem' }}>5. Prohibited Use</h2>
            <p style={{ marginBottom: '1rem' }}>You agree NOT to use Aramco Leads Pro for:</p>
            <ul style={{ marginBottom: '2rem', paddingLeft: '2rem' }}>
              <li>Unsolicited messages or spam</li>
              <li>Purchased or scraped contact lists</li>
              <li>Messages without proper consent</li>
              <li>Illegal or harmful content</li>
              <li>Deceptive or misleading loan offers</li>
              <li>Predatory lending practices</li>
            </ul>

            <h2 style={{ color: '#1e40af', marginBottom: '1rem', fontSize: '1.75rem' }}>6. Opt-Out Policy</h2>
            <p style={{ marginBottom: '2rem' }}>
              Customers may opt-out at any time by sending STOP, UNSUBSCRIBE, CANCEL, or QUIT. 
              We enforce immediate message cessation upon opt-out requests.
            </p>

            <h2 style={{ color: '#1e40af', marginBottom: '1rem', fontSize: '1.75rem' }}>7. Service Fees</h2>
            <p style={{ marginBottom: '2rem' }}>
              Service fees are based on your selected plan and usage. Payment is due according to your billing cycle. 
              We reserve the right to suspend services for non-payment.
            </p>

            <h2 style={{ color: '#1e40af', marginBottom: '1rem', fontSize: '1.75rem' }}>8. Limitation of Liability</h2>
            <p style={{ marginBottom: '2rem' }}>
              Aramco Leads Pro shall not be liable for any indirect, incidental, special, consequential, or punitive damages 
              resulting from your use of our services.
            </p>

            <h2 style={{ color: '#1e40af', marginBottom: '1rem', fontSize: '1.75rem' }}>8. Account Termination</h2>
            <p style={{ marginBottom: '2rem' }}>
              We reserve the right to suspend or terminate accounts that violate compliance rules or engage in prohibited activities.
            </p>

            <h2 style={{ color: '#1e40af', marginBottom: '1rem', fontSize: '1.75rem' }}>9. Contact Information</h2>
            <div style={{ background: '#f9fafb', padding: '2rem', borderRadius: '12px', border: '1px solid #e5e7eb' }}>
              <p style={{ fontWeight: '600', marginBottom: '1rem' }}>Aramco 1 USA Corporation</p>
              <p><strong>DBA:</strong> Aramco Leads Pro</p>
              <p>11 Linden Ave<br />Kearny, NJ 07032<br />United States</p>
              <p><strong>EIN:</strong> 33-1773365</p>
              <p style={{ marginTop: '1rem' }}><strong>Email:</strong> legal@aramcoleadspro.com</p>
              <p><strong>Support:</strong> support@aramcoleadspro.com</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
